module.exports = "<tr class=\"danger text-danger text-center\">\n    <td colspan=\"4\">\n        You may not grant permission to any team in this organization. <br>\n        Since you do not have modify permissions, you may not create or modify anything for this organization\n    </td>\n</tr>";


//////////////////
// WEBPACK FOOTER
// ./srv/public/js/templates/modals/noPermission.html
// module id = 565
// module chunks = 7